module.exports = __webpack_public_path__ + "static/sobrenosotros-b9a39fb4d8c58c1c2320196c6fef3a9a.jpg";